import ApiClient from "./ApiClient"

import DataSource  from "../types/DataSource"

export const DataSourceApi = {

    apiPath: 'data-sources',

    get: async (id: number, include?: string): Promise<DataSource> => {

        let url: string = DataSourceApi.apiPath + '/' + id

        if (include) {
            url += `?include=${include}`
        }

        const response = await ApiClient.get(url)

        return response.data.data
    },

    getAll: async (search?: string): Promise<DataSource[]> => {
        const items: DataSource[] = []
        const params = new URLSearchParams([
            ['lockingSystemId', localStorage.getItem('selectedLockingSystemId') as string]
        ])

        if (search) params.append('search', search)

        const response = await ApiClient.get(DataSourceApi.apiPath, { params });

        for (let item of response.data.data) {
            items.push(item)
        }

        return items
    },

    add: async (newDataSource: DataSource, handleAddItem: (id: number) => void): Promise<DataSource> => {

        const result = await ApiClient.post(DataSourceApi.apiPath, newDataSource);

        const itemRef = result.data.data;

        handleAddItem(itemRef.id);

        return result?.data.data
    },

    delete: async(id: number): Promise<any> => {

        return await ApiClient.delete(DataSourceApi.apiPath + '/' + id);

    },

    edit: async (dataSource: DataSource): Promise<DataSource> => {

        const result = await ApiClient.put(
            DataSourceApi.apiPath + '/' + dataSource.id, dataSource
        );

        return result?.data.data
    },

    toggle: async (dataSource: DataSource, values: object): Promise<any> => {

        const result = await ApiClient.put(
            DataSourceApi.apiPath + '/' + dataSource.id + '/toggle', values
        );

        return result?.data.data
    }
}